module.exports = {
  commands: {
    reCheckRecommendations: {
      name: 'reCheckRecommendations',
      command: 'command:recheck-recommendations',
    },
  },
};
